import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { BlockDTO } from "src/app/shared/models/block-dto";
import { SearchFormDTO } from "../../modules/private/modules/fleet-admin/components/models/search-form-dto";
import { FleetAdminDTO } from "../../shared/models/fleet-admin-dto";
import { EmailDTO } from "src/app/shared/models/email-dto";
import { Pagination } from "@shared/models/pagination";
import { PageManager } from "@shared/models/page-manager";
import { Sort } from "@angular/material/sort";
import { populateParamsWithSortValues } from "@shared/helper/string-sort";
import { populateParamsWithNotEmptyValues } from "@shared/helper";

@Injectable({
  providedIn: "root"
})
export class FleetAdminService {
  private fleetAdminUrl = "fleet-administrators/";
  id: any;
  constructor(private http: HttpClient) {}

  private buildFleetAdminPayload(fleetAdminDTO: FleetAdminDTO): FleetAdminDTO {
    const { isSalesApprover, ...payload } = fleetAdminDTO;

    return {
      ...payload,
      admPerfil: fleetAdminDTO.admPerfil ?? isSalesApprover
    };
  }

  verifyShowInvoicesPartsServicesByUser() {
    return this.http.get<any>(
      environment.apiUrl + this.fleetAdminUrl + "show-parts-and-services"
    );
  }

  save(fleetAdminDTO: FleetAdminDTO): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + this.fleetAdminUrl,
      this.buildFleetAdminPayload(fleetAdminDTO)
    );
  }

  listAll(): Observable<FleetAdminDTO[]> {
    return this.http.get<FleetAdminDTO[]>(
      environment.apiUrl + this.fleetAdminUrl
    );
  }

  listApprovalUsersTech(id?: number | null): Observable<FleetAdminDTO[]> {
    const clientId = id ?? null;

    return this.http.get<FleetAdminDTO[]>(
      `${environment.apiUrl}${this.fleetAdminUrl}approval-users-tech/client/${clientId}`
    );
  }

  associateBlock(id: number, blockId: number, block: Object): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + `${this.fleetAdminUrl}${id}/blocks/${blockId}`,
      block
    );
  }

  disassociateBlock(id: number, blockId: number): Observable<any> {
    return this.http.delete<any>(
      environment.apiUrl + `${this.fleetAdminUrl}${id}/blocks/${blockId}`
    );
  }

  listAllBlockByFleetAdmin(id: number): Observable<BlockDTO[]> {
    return this.http.get<BlockDTO[]>(
      environment.apiUrl + `${this.fleetAdminUrl}${id}/blocks`
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      environment.apiUrl + `${this.fleetAdminUrl}${id}`
    );
  }

  findById(id: number): Observable<FleetAdminDTO> {
    return this.http.get<FleetAdminDTO>(
      environment.apiUrl + `${this.fleetAdminUrl}${id}`
    );
  }

  edit(id: number, fleetAdminDTO: FleetAdminDTO): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + `${this.fleetAdminUrl}${id}`,
      this.buildFleetAdminPayload(fleetAdminDTO)
    );
  }

  buildQueryForFilters(searchFormDTO: SearchFormDTO): string {
    let query = "";

    if (searchFormDTO.blockId) {
      query += `blockId=${searchFormDTO.blockId}`;
    }
    if (searchFormDTO.name) {
      query += `&name=${searchFormDTO.name}`;
    }
    if (searchFormDTO.parentId) {
      query += `&parentId=${searchFormDTO.parentId}`;
    }

    return query;
  }

  findByFiltersPaginated(
    searchFormDTO: SearchFormDTO,
    pageManager?: PageManager,
    sort?: Sort
  ): Observable<Pagination<FleetAdminDTO[]>> {
    let params = new HttpParams();
    params = params.append("page", pageManager.pageIndex.toString());
    params = params.append("size", pageManager.pageSize.toString());

    params = populateParamsWithSortValues(sort, params);

    params = populateParamsWithNotEmptyValues(searchFormDTO, params);

    return this.http.get<Pagination<FleetAdminDTO[]>>(
      `${environment.apiUrl}v2/${this.fleetAdminUrl}`,
      { params }
    );
  }

  sendEmailByFilters(searchFormDTO: SearchFormDTO, emailDTO: EmailDTO) {
    const query = this.buildQueryForFilters(searchFormDTO);

    return this.http.post<any>(
      `${environment.apiUrl}${this.fleetAdminUrl}email?${query}`,
      emailDTO
    );
  }
}
